import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { v4 as uuidv4 } from "uuid";
import classes from './Card.module.css'

const CarouselComponent = ({data}) => {

  const repeatObjects = (arr,number=4) => {
    if (arr.length >= number) return arr; // If already 4 or more, return as is
  
    let repeatedArr = [...arr]; // Clone the original array
  
    while (repeatedArr.length < number) {
      repeatedArr = [...repeatedArr, ...arr]; // Repeat the original array
    }
  
    return repeatedArr.slice(0, Math.max(number, arr.length * 2)); // Ensure correct length
  }

    const swiperRef = useRef(null);

    const slides = [
        { id: 1, url: "https://img.freepik.com/premium-photo/modern-automobile-classic-technology-wheel-traffic_665346-119.jpg" },
        { id: 2, url: "https://img.freepik.com/premium-photo/modern-automobile-classic-technology-wheel-traffic_665346-119.jpg" },
        { id: 3, url: "https://img.freepik.com/premium-photo/modern-automobile-classic-technology-wheel-traffic_665346-119.jpg" },
        { id: 4, url: "https://img.freepik.com/premium-photo/modern-automobile-classic-technology-wheel-traffic_665346-119.jpg" },
        { id: 5, url: "https://img.freepik.com/premium-photo/modern-automobile-classic-technology-wheel-traffic_665346-119.jpg" },
      ];
    

  return (
    <div className="slider3d about-carousels">
    <div style={{ position: "relative", width: "100%", margin: "auto" }}>
      {/* Custom Navigation Arrows */}

      {/* Swiper */}
      <Swiper
        slidesPerView={3} // Show 3 images at a time
        allowTouchMove={false}
        spaceBetween={20} // Add space between slides
        onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
        pagination={{ clickable: true }} // Enable clickable dots
        loop={true} // Enable infinite looping/ Add space for pagination dots
        draggable={false} // Enable drag/swipe functionality
        className={`${classes.aboutSwiper} about-carousels`}
        modules={[Pagination,Autoplay]} // Import pagination module
        initialSlide={2}
        autoplay={{
          delay: 3000, // 3 seconds
          disableOnInteraction: false, // Autoplay continues even after interaction
        }}
      >
        {repeatObjects(data)?.map((slide) => (
          <SwiperSlide key={slide.id}>
            <img
              src={slide.url}
              className = {classes.carouselImage}
              alt={slide?.imageTag}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </div>

  );
};

export default CarouselComponent;
